import React, { useContext } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { SnackbarAlert } from "../SnackbarAlert";
import firebase from "../../firebase";

import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  card: {
    boxShadow: "0 4px 6px 0 hsla(0, 0%, 0%, 0.2)",
    width: "auto",
    height: 272,
    //minHeight: 322,
  },
  cardHeader: {
    borderTop: `6px solid ${theme.palette.primary.dark}`,
  },
  paperActions: {
    //width: "inherit",
    //position: "fixed",
    //marginTop: "auto",
    //marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
    //background: "hsl(0, 0%, 97%)",
    //padding: theme.spacing(2),
  },
  paperContent: {
    //padding: theme.spacing(2, 2),
    marginTop: theme.spacing(2),
  },
  removeButton: {
    color: theme.palette.error.main,
  },
  setButton: {
    marginBottom: theme.spacing(1),
    color: theme.palette.common.white,
    background: theme.palette.primary.main,
    "&:hover": {
      background: theme.palette.primary.dark,
    },
  },
}));
const MakeAdmin = () => {
  const classes = useStyles();
  const makeUserAdmin = firebase.functions().httpsCallable("makeUserAdmin");
  const { setSnackbarState } = useContext(SnackbarAlert);
  return (
    <Formik
      initialValues={{
        email: "",
        selectedButton: "",
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .required("Please input your email")
          .email("Invalid format"),
        selectedButton: Yup.string(),
      })}
      onSubmit={async (values, actions) => {
        try {
          switch (values.selectedButton) {
            case "set-privilege":
              await makeUserAdmin({
                email: values.email,
                addPrivilege: true,
              });
              //throw new Error("This sucks");
              actions.resetForm();
              setSnackbarState({
                state: true,
                message: "User successfully made as admin! 👍",
                status: "info",
              });
              break;
            case "remove-privilege":
              await makeUserAdmin({
                email: values.email,
                addPrivilege: false,
              });
              actions.resetForm();
              setSnackbarState({
                state: true,
                message: "User successfully removed as admin! 👍",
                status: "info",
              });
              break;
            default:
              throw new Error("selectedButton is empty");
            //break;
          }
        } catch (error) {
          //console.log(error);
          actions.resetForm();
          setSnackbarState({
            state: true,
            message: "Something went wrong. 😟",
            status: "error",
          });
        }
      }}
    >
      {(formik) => (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            //formik.handleSubmit();
          }}
          noValidate
        >
          <div>
            <Typography component="label">
              <Box
                fontSize={28}
                display="block"
                fontWeight="fontWeightBold"
                lineHeight={1}
                p={1}
              >
                Set Admin Privilege
              </Box>
            </Typography>

            <Typography component="div" className={classes.paperContent}>
              <TextField
                id="email"
                name="email"
                placeholder="Email ID"
                margin="dense"
                variant="filled"
                color="primary"
                {...formik.getFieldProps("email")}
                error={formik.errors.email && formik.touched.email}
                helperText={
                  formik.errors.email && formik.touched.email
                    ? formik.errors.email
                    : "Email ID"
                }
                disabled={formik.isSubmitting}
                autoComplete="off"
                fullWidth
              />
            </Typography>
            <Typography component="div" className={classes.paperActions}>
              <Box display="block">
                <Button
                  id="set-privilege"
                  variant="contained"
                  type="submit"
                  disableElevation
                  className={classes.setButton}
                  fullWidth
                  disabled={formik.isSubmitting}
                  onClick={(e) => {
                    formik.setFieldValue("selectedButton", e.currentTarget.id);
                    setTimeout(() => {
                      formik.handleSubmit();
                    }, 0);
                  }}
                >
                  Set privilege
                </Button>
              </Box>
              <Box display="block">
                <Button
                  id="remove-privilege"
                  variant="text"
                  type="submit"
                  disableElevation
                  className={classes.removeButton}
                  fullWidth
                  disabled={formik.isSubmitting}
                  onClick={(e) => {
                    formik.setFieldValue("selectedButton", e.currentTarget.id);
                    setTimeout(() => {
                      formik.handleSubmit();
                    }, 0);
                  }}
                >
                  Remove privilege
                </Button>
              </Box>
            </Typography>
          </div>
        </form>
      )}
    </Formik>
  );
};

export default MakeAdmin;
